// @ts-check
import EntitySettings from './EntitySettings';

export default EntitySettings;
